import React from 'react';
import { Button, Modal, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isNumberEnteredValid, isNameValid } from 'services/Validation';

const MIN_PRIORITY = 0;
const MAX_PRIORITY = 100;

class ProjectPriorityAdd extends React.Component {
    constructor(props) {
        super(props);
        const { updatingGlobalPriorities } = this.props;
        const { id, name, description, value, } = props.projectPriority;
        this.state = {
            id,
            name,
            description,
            value,
            nameValid: updatingGlobalPriorities ? true : isNameValid(name),
            valueValid: updatingGlobalPriorities ? isNumberEnteredValid(value, MIN_PRIORITY, MAX_PRIORITY) : true,
            formErrors: { name: '', value: '', number: '' },
            formValid: false,
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleUserNumberInput = (e) => {
        let fieldValidationErrors = this.state.formErrors;
        const name = e.target.name;
        let value = Number(e.target.value);
        // TODO injects NaN into the field so need to display message and revert/block the change
        if (isNaN(value)) {
            fieldValidationErrors.number = ' - the entry must be a number.';
            const { [name]: origValue } = this.state;
            this.setState({ [name]: origValue });
        } else {
            fieldValidationErrors.number = '';
            this.setState(
                { [name]: value },
                () => { this.validateField(name, value); } // run this call back on state change
            );
        }
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let nameValid = this.state.nameValid;
        let valueValid = this.state.valueValid;
        const { updatingGlobalPriorities } = this.props;

        switch (fieldName) {
            case 'name':
                if (updatingGlobalPriorities) {
                    nameValid = isNameValid(value);
                    fieldValidationErrors.name = nameValid ? '' : ' is invalid';
                } else {
                    nameValid = true; // not required when changing individual project priorities - only the value can be changed
                    fieldValidationErrors.name = '';
                }
                break;
            case 'value':
                if (!updatingGlobalPriorities) {
                    valueValid = isNumberEnteredValid(value, MIN_PRIORITY, MAX_PRIORITY);
                    fieldValidationErrors.value = valueValid ? '' : ' is invalid. It must be a number > '.concat(MIN_PRIORITY).concat(' and <= ').concat(MAX_PRIORITY);
                } else {
                    valueValid = true; // not required when changing all the project priorities - just the name is required
                    fieldValidationErrors.value = '';
                }
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            nameValid,
            valueValid,
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.nameValid && this.state.valueValid });
    }

    updateProjectPriority = () => {
        const { id, name, description, value } = this.state;
        const {
            showProjectPriorityLoader,
            onSaveProjectPriority,
            updatingGlobalPriorities,
            onProjectPriorityClose,
            showProjectLoader,
            onUpdateProjectPriorities,
        } = this.props;
        const data = {
            'id': id,
            'name': name,
            'description': description,
            'value': value,
        };
        onProjectPriorityClose();
        if (updatingGlobalPriorities) {
            showProjectLoader();
            onUpdateProjectPriorities(data); // calls the api to update all corresponding priorities
        } else {
            showProjectPriorityLoader();
            onSaveProjectPriority(data); // just update the one instance - not all
        }
        this.setState({
            id: '',
            name: '',
            active: true,
            value: 0,
            formErrors: { name: '', value: '', number: '' },
            formValid: false,
        });
    }

    render() {
        const {
            onProjectPriorityClose,
            open,
            projectPriority,
            updatingGlobalPriorities,
        } = this.props;
        const { name, description, value } = this.state;
        const isNew = projectPriority.id === '';
        let { thumb } = this.state;
        return (
            <Modal className="modal-box" toggle={onProjectPriorityClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    {isNew ? <IntlMessages id="projectPriority.addProjectPriority" /> :
                        <IntlMessages id="projectPriority.saveProjectPriority" />}
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onProjectPriorityClose} />
                    </span>
                </ModalHeader>

                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <div className="col-lg-3 text-center text-lg-right order-lg-2">
                            <img className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={thumb} />
                        </div>

                        <div className="panel panel-default">
                            <FormErrors formErrors={this.state.formErrors} />
                        </div>

                        <div className="col-lg-9 d-flex flex-column order-lg-1">
                            <input type="text" className="form-control mb-2"
                                placeholder="Name"
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={name} name="name"
                                disabled={!updatingGlobalPriorities}
                            />
                            <input type="text" className="form-control mb-2"
                                placeholder="Description"
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={description} name="description"
                                disabled={!updatingGlobalPriorities}
                            />
                            {updatingGlobalPriorities ?
                                null
                                : <input type="text" className="form-control mb-2"
                                    placeholder="Value"
                                    onChange={(event) => this.handleUserNumberInput(event)}
                                    value={value} name="value"
                                />}
                        </div>
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                        this.updateProjectPriority();
                    }}>
                        {isNew ? <IntlMessages id="projectPriority.addProjectPriority" /> :
                            <IntlMessages id="projectPriority.saveProjectPriority" />}</Button>
                </div>
            </Modal>
        );
    }
}

export default ProjectPriorityAdd;


// WEBPACK FOOTER //
// ./components/Agile/projectPriority/projectPriorityAdd/index.js